import classNames from "classnames";
import { isFunction } from "lodash-es";
import React, { ReactNode } from "react";

export interface ITabChildProps {
  active?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export interface ITabProps extends Pick<ITabChildProps, "active" | "disabled"> {
  className?: string;
  index?: number;
  onClick?: (index?: number, to?: string) => void;
  children: ((childProps: ITabChildProps) => ReactNode) | ReactNode;
}

export class Tab extends React.PureComponent<ITabProps> {
  handleClick = () => {
    if (this.props.disabled) {
      return;
    }

    const { onClick, index } = this.props;
    if (onClick) {
      onClick(index);
    }
  };

  render() {
    const { children, className, active, disabled } = this.props;

    const classes = classNames(
      "el-tab-list__item",
      {
        "el-tab-list__item--active": !!active,
        "el-tab-list__item--disabled": !!disabled,
      },
      className,
    );

    const props = Object.assign(
      {
        className: classes,
        tabIndex: disabled ? -1 : 0,
      },
      isFunction(children) ? {} : { onClick: this.handleClick },
    );

    return (
      <div {...props}>
        {isFunction(children) ? children({ active, disabled, onClick: this.handleClick }) : children}
      </div>
    );
  }
}
